<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-tabset></settings-tabset>

      <!-- Profile Availability -->
      <div class="row">
        <div class="col-md-12">
          <div class="profile-availability">
            <div class="select-days">
              <h4>Select days</h4>
              <ul class="day-list">
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_1"
                      name="day"
                      checked
                    />
                    <label for="select_days_1"> Mon </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_2"
                      name="day"
                    />
                    <label for="select_days_2"> Tues </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_3"
                      name="day"
                    />
                    <label for="select_days_3"> Wed </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_4"
                      name="day"
                    />
                    <label for="select_days_4"> Thur </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_5"
                      name="day"
                    />
                    <label for="select_days_5"> Fri </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_6"
                      name="day"
                    />
                    <label for="select_days_6"> Sat </label>
                  </div>
                </li>
                <li>
                  <div class="day-selection">
                    <input
                      type="checkbox"
                      value="attach_link"
                      id="select_days_7"
                      name="day"
                    />
                    <label for="select_days_7"> Sun </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="accordion setting-accordion">
              <!-- Monday -->
              <div class="accordion-item" id="day-monday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#monday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_1" class="check" />
                        <label for="status_1" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Monday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="monday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursID"
                            id="hoursid"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Monday -->

              <!-- Tuesday -->
              <div class="accordion-item" id="day-tuesday">
                <div class="accordion-header">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#tuesday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_2" class="check" checked />
                        <label for="status_2" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Tuesday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="tuesday" class="accordion-collapse collapse show">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDOne"
                            id="hoursidone"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Tuesday -->

              <!-- Wednessday -->
              <div class="accordion-item" id="day-wednesday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#wednesday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_3" class="check" />
                        <label for="status_3" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Wednesday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="wednesday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDTwo"
                            id="hoursidtwo"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Wednessday -->

              <!-- Thursday -->
              <div class="accordion-item" id="day-thursday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#thursday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_4" class="check" />
                        <label for="status_4" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Thursday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="thursday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDThree"
                            id="hoursidthree"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Thursday -->

              <!-- Friday -->
              <div class="accordion-item" id="day-friday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#friday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_5" class="check" />
                        <label for="status_5" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Friday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="friday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDFour"
                            id="hoursidfour"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Friday -->

              <!-- Saturday -->
              <div class="accordion-item" id="day-saturday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#saturday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_6" class="check" />
                        <label for="status_6" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Saturday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="saturday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDFive"
                            id="hoursidfive"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Saturday -->

              <!-- Sunday -->
              <div class="accordion-item" id="day-sunday">
                <div class="accordion-header">
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#sunday"
                  >
                    <div class="interset-btn empty-space">
                      <div class="status-toggle d-inline-flex align-items-center">
                        <input type="checkbox" id="status_7" class="check" />
                        <label for="status_7" class="checktoggle">checkbox</label>
                      </div>
                    </div>
                    <span class="accord-title">Sunday</span>
                    <a href="javascript:void(0);">Edit</a>
                  </div>
                </div>
                <div id="sunday" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <div class="row gx-2">
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Duration <span class="text-danger">*</span></label
                          >
                          <vue-select
                            :options="HoursIDSix"
                            id="hoursidsix"
                            placeholder="1 Hrs"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >Start Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="duration-blk">
                          <label class="form-control-label"
                            >End Time <span class="text-danger">*</span></label
                          >
                          <div class="form-icon">
                            <input
                              type="text"
                              class="form-control datetimepicker1"
                              placeholder="Select time"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4>Available Timings</h4>
                        <div class="token-slot mt-2">
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                value="18"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 AM"
                                >06:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:00:00"
                                data-end-time="15:20:00"
                                data-session="1"
                                name="token[]"
                                value="19"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 AM"
                                >07:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:20:00"
                                data-end-time="15:40:00"
                                data-session="1"
                                name="token[]"
                                value="20"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="08:00 AM"
                                >08:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="15:40:00"
                                data-end-time="16:00:00"
                                data-session="1"
                                name="token[]"
                                value="21"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="09:00 AM"
                                >09:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:00:00"
                                data-end-time="16:20:00"
                                data-session="1"
                                name="token[]"
                                value="22"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="10:00 AM"
                                >10:00 AM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:20:00"
                                data-end-time="16:40:00"
                                data-session="1"
                                name="token[]"
                                value="23"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="11:00 PM"
                                >11:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="16:40:00"
                                data-end-time="17:00:00"
                                data-session="1"
                                name="token[]"
                                value="24"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="12:00 PM"
                                >12:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:00:00"
                                data-end-time="17:20:00"
                                data-session="1"
                                name="token[]"
                                value="25"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="01:00 PM"
                                >01:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:20:00"
                                data-end-time="17:40:00"
                                data-session="1"
                                name="token[]"
                                value="26"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="02:00 PM"
                                >02:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="17:40:00"
                                data-end-time="18:00:00"
                                data-session="1"
                                name="token[]"
                                value="27"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="03:00 PM"
                                >03:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:00:00"
                                data-end-time="18:20:00"
                                data-session="1"
                                name="token[]"
                                value="28"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="04:00 PM"
                                >04:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:20:00"
                                data-end-time="18:40:00"
                                data-session="1"
                                name="token[]"
                                value="29"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="05:00 PM"
                                >05:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="18:40:00"
                                data-end-time="19:00:00"
                                data-session="1"
                                name="token[]"
                                value="30"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="06:00 PM"
                                >06:00 PM</span
                              >
                            </label>
                          </div>
                          <div class="form-check-inline visits me-0">
                            <label class="visit-btns">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                data-date="2021-05-21"
                                data-timezone="Asia/Calcutta"
                                data-start-time="19:00:00"
                                data-end-time="19:20:00"
                                data-session="1"
                                name="token[]"
                                value="31"
                              />
                              <span
                                class="visit-rsn"
                                data-bs-toggle="tooltip"
                                title="07:00 PM"
                                >07:00 PM</span
                              >
                            </label>
                          </div>
                        </div>
                        <div class="save-time">
                          <a href="javascript:void(0);">Save Timings</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Sunday -->
            </div>
            <div class="save-changes text-end">
              <a href="javascript:;" class="btn btn-primary reset-profile">Reset</a>
              <a href="javascript:;" class="btn btn-secondary save-profile"
                >Save Change</a
              >
            </div>
          </div>
        </div>
      </div>
      <!-- /Profile Availability -->
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      HoursID: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDOne: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDTwo: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDThree: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDFour: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDFive: ["1 Hrs", "2 Hrs", "3 Hrs"],
      HoursIDSix: ["1 Hrs", "2 Hrs", "3 Hrs"],
      title: "Availability",
      text: "Home",
      text1: "Availability",
    };
  },
};
</script>
